import { useForm } from 'react-hook-form';
import { Step } from './Step';
import { useTranslation } from 'react-i18next';

type Props = {
  isActive: boolean;
  isDone: boolean;
  onNext: () => void;
  onActivate: () => void;
};
export const StepIntroduction = ({ onNext, isActive, isDone, onActivate }: Props) => {
  const form = useForm({});

  const { t } = useTranslation();

  return (
    <Step
      question={t('wedding.headline')}
      form={form}
      onNext={onNext}
      isActive={isActive}
      isDone={isDone}
      onActivate={onActivate}
      ctaText={t('start')}>
      <p />
    </Step>
  );
};
